import { render, staticRenderFns } from "./ModalStatusRenewal.vue?vue&type=template&id=6dec1d1c"
import script from "./ModalStatusRenewal.vue?vue&type=script&lang=js"
export * from "./ModalStatusRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports